import { default as antdTheme } from 'antd/es/theme';
import { useTheme } from './hooks/useTheme';

export const CUSTOM_TAB_STYLE = {
  backgroundColor: '#003C3C',
  borderTopLeftRadius: '8px',
  borderTopRightRadius: '8px',
  padding: '0px',
  color: 'white'
};

const ANTD_INPAY_DOCS_THEME = {
  colorBgBase: '#003c3c',
  token: {
    colorPrimary: '#0B4B4B',
    borderRadius: 12,
    Select: {
      colorPrimary: 'rgb(73, 125, 46)',
      optionSelectedColor: 'rgba(0, 0, 0, 0.88)',
      optionSelectedBg: 'rgba(234, 234, 234, 0.27)'
    },
    Dropdown: {
      controlItemBgActiveHover: 'rgb(197, 206, 204)',
      controlItemBgActive: 'rgba(197, 206, 204, 0.6)'
    },
    Collapse: {
      colorBorder: 'rgba(217, 217, 217, 0)',
      headerBg: 'rgba(0, 0, 0, 0.04)'
    },
    Tabs: {
      colorPrimary: 'white',
      cardBg: '#142C2C',
      cardGutter: '0px',
      colorBgContainer: '#142C2C',
      colorBorder: '#142C2C',
      colorBorderSecondary: '#142C2C',
      margin: '0px',
      colorText: 'white',
      itemColor: 'white',
      itemActiveColor: 'white',
      itemHoverColor: 'white',
      horizontalItemPadding: '8px'
    }
  }
};

export const useCustomAntdTheme = () => {
  const { theme } = useTheme();

  const customTheme = {
    algorithm:
      theme === 'light' ? antdTheme.defaultAlgorithm : antdTheme.darkAlgorithm,
    ...ANTD_INPAY_DOCS_THEME
  };

  return customTheme;
};
